export default __webpack_public_path__ + "static/media/Delivery de Flores.380eca4c.jpg";